import { image_pb } from 'libs/generated-grpc-ts';

import { MembershipListType } from '../';

export interface IMembershipList {
  id?: number;
  name?: string;
  assetPath?: string;
  assetId?: number;
  bannerHash?: string;
  bannerImage?: image_pb.ImageInfo;
  memberCount?: number;
  priority?: number;
  active?: boolean;
  listType?: MembershipListType;
  members?: string[];
  memberIds?: number[];
  contentId?: number;
  contentHash?: string;
  contextHash?: string;
  color?: string;
  uuid?: string;
  description?: string;
  updateTime?: any;
  public?: boolean;
  creator?: IMembershipListMember;
  managerListId?: number;
  sourcedId?: string;
  deletedAt?: Date;
  deniedPasses?: number;
  terms?: string[];
  periods?: string[];
  location?: string;
  sectionSisId?: string;
  sectionSisNumber?: string;
  isHomeroom?: boolean;
  flags?: MembershipListFlags[];
}

export enum MembershipListFlags {
  HALL_PASS_ENABLED = 'HALL_PASS_ENABLED',
  FLEX_TIME_ENABLED = 'FLEX_TIME_ENABLED',
  ROLE_GENERATED = 'ROLE_GENERATED',
  TEACHER_GENERATED = 'TEACHER_GENERATED',
  GRADE_GENERATED = 'GRADE_GENERATED',
  SUBJECT_GENERATED = 'SUBJECT_GENERATED',
}

export const GENERATED_MEMBERSHIP_LIST_FLAGS: MembershipListFlags[] = [
  MembershipListFlags.ROLE_GENERATED,
  MembershipListFlags.TEACHER_GENERATED,
  MembershipListFlags.GRADE_GENERATED,
  MembershipListFlags.SUBJECT_GENERATED,
];

export interface IMembershipListMinimal {
  id?: number;
  name?: string;
  active?: boolean;
  public?: boolean;
  listType?: MembershipListType;
  memberCount?: number;
  members?: IMembershipListMember[];
  memberIds?: number[];
  creator?: IMembershipListMember;
}

interface IMembershipListMember {
  hash: string;
  firstName: string;
  lastName: string;
}
